<template>
    <v-layout class="d-flex justify-center align-center h-screen">
        <slot></slot>
    </v-layout>
</template>

<script setup>
import {useRoute} from "vue-router";
import {useAuthStore} from "@/stores/authStore";
import {landingRoute, useNavigation} from "@/composables/globals";

const route = useRoute()
const {navigateTo} = useNavigation()
const authStore = useAuthStore()

// Allow password reset pages even when authenticated
const allowedRoutes = ['forgot-password', 'reset-password', 'verify-email']
const isAllowedRoute = allowedRoutes.includes(route.name)

if (authStore.isAuthenticated() && !isAllowedRoute) {
    navigateTo(landingRoute(authStore))
}
</script>
